import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { OrderResponse } from '../../../models/orders/order.model';

@Component({
  selector: 'app-display-order-information',
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
  ],
  templateUrl: './display-order-information.component.html',
  styleUrl: './display-order-information.component.scss'
})
export class DisplayOrderInformationComponent {

@Input() order: OrderResponse;

}
